// Generated by Copilot — Migrated from Userfront SignupForm to Clerk SignUp
import React from 'react';
import { SignUp } from "@clerk/react";
import './Login.css';

const Signup = () => {
  return (
    <div className="login-container">
      <div className="login-wrapper">
        {/* Left Column - Welcome Section */}
        <div className="login-left">
          <div className="welcome-content">
            <h1 className="welcome-title">Únete a SatGO</h1>
            <p className="welcome-description">
              Simplificamos la gestión fiscal con tecnología de última generación. 
              Todo lo que necesitas del SAT en un solo lugar.
            </p>
            <div className="features-list">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Descarga de Constancias de Situacion Fiscal</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Descarga de Declaraciones</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Y mas...</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Signup Form */}
        <div className="login-right">
          <div className="form-container">
            <img src="satgo-banner-bg.png" alt="SatGO" className="form-logo" />
            <SignUp 
              signInUrl="/login"
              appearance={{
                variables: {
                  colorPrimary: '#13a0ff',
                  fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
